<template>
     <div v-show="parent2Show">
        <Row>
            <Col span="20">
                <div v-for="(item,index) in getData" :key="index">
                    <component :is="item.model" :msg="item"></component>
                </div>
            </Col>
            <Col span="4" v-show="getData.length != 0">
                <h3 class="hd">基础信息</h3>
                <Form ref="form" :model="formItem" :rules="formValidate">
                    <Form-item label="模板名称" prop="name">
                        <Input type="text" v-model="formItem.name" placeholder="请输入..."/>
                    </Form-item>
                    <Form-item label="说明" prop="prompt">
                        <Input type="textarea" v-model="formItem.prompt" placeholder="请输入..."/>
                    </Form-item>
                </Form>
                <Button @click="submitFn">保存建立</Button>
            </Col>
        </Row>
    </div>
</template>
<script>
    import mod from './mod'
    export default {
        data(){
            return{
                formItem:{
                    temid:this.$route.query.temid,
                    name:'',
                    prompt:'',
                    textval:'',
                    type:'',
                },
                getData:[],
                formValidate:{
                    name: [
                        { required: true, message: '模板名称不能为空', trigger: 'change' }
                    ],
                    prompt: [
                        { required: true, message: '模板名称不能为空', trigger: 'change' }
                    ],
                    td: [
                        { required: true, message: '表头名称不能为空', trigger: 'change' }
                    ],
                },
            }
        },
        watch:{
            $route(to,from){
                if(to.path == '/templateList/addTemplate'){
                    this.$store.dispatch('parent2ShowFn');
                };
            }
        },
        computed: {
            parent2Show () {
                return this.$store.state.parent2Show;
            }
        },
        created(){
            this.$store.dispatch('parent2ShowFn');
            this.getDataFn()
        },
        methods:{
            submitFn(){
                var _this=this;
                this.$refs.form.validate((valid) => {
                    if(valid){
                        switch(this.getData[0].type){
                            case 1:
                                for(var i=0; i<this.getData[0].data.length; i++){
                                    if(this.getData[0].data[i].btnName == '未设置'){
                                        this.$Notice.error({
                                            title:'新增模板',
                                            desc:'还有未设置的选项'
                                        });
                                        return false;
                                    }
                                }
                                break;
                            case 2:
                                for(var name in this.getData[0].data){
                                    for(var i=0; i<this.getData[0].data[name].length; i++){
                                        if(this.getData[0].data[name][i].btnName == '未设置'){
                                            this.$Notice.error({
                                                title:'新增模板',
                                                desc:'还有未设置的选项'
                                            });
                                            return false;
                                        }
                                    }
                                }
                                break;
                            case 3:
                                for(var name in this.getData[0].data){
                                    for(var i=0; i<this.getData[0].data[name].length; i++){
                                        for(var item in this.getData[0].data[name][i]){
                                            for(var j=0; j<this.getData[0].data[name][i][item].length; j++){
                                                if(this.getData[0].data[name][i][item][j].btnName == '未设置'){
                                                    this.$Notice.error({
                                                        title:'新增模板',
                                                        desc:'还有未设置的选项'
                                                    });
                                                    return false;
                                                }
                                            }
                                        }

                                    }
                                }
                                break;
                        }
                        this.formItem.textval=JSON.stringify(this.getData[0].data);
                        this.formItem.type=this.getData[0].type;
                        this.$http.post('/web/template/updateTemplate',_this.formItem).then(function(res){
                            if(res.success){
                                _this.$Notice.success({
                                    title:'修改模板',
                                    desc:res.message
                                });
                                _this.$router.push({path:'/templateList'});
                            }else{
                                _this.$Notice.error({
                                    title:'修改模板',
                                    desc:res.message
                                });
                            }
                        }).catch(function(res){
                            _this.$Notice.error({
                                title:'修改模板',
                                desc:'数据请求失败'
                            });
                        });
                    } else {
                        _this.$Message.error('表单验证失败!');
                    }
                });
            },
            getDataFn(){
                var _this=this;
                this.$http.get('/web/template/getTemplateByTemid',{
                    params:{
                        temid:_this.$route.query.temid
                    }
                }).then(function(res){
                    _this.getData=[];
                    _this.formItem.name=res.data.name;
                    _this.formItem.prompt=res.data.prompt;
                    _this.formItem.type=res.data.type;
                    var msg=JSON.parse(res.data.textval);
                    var model='';
                    var batch={};
                    var init={};
                    switch(res.data.type){
                        case 1:
                            model = 'one';
                            batch=[];
                            break;
                        case 2:
                            model = 'two';
                            for(let name in msg){
                                batch[name]=[];
                                init[name]=[];
                            }
                            break;
                        case 3:
                            model = 'three';
                            for(let name in msg){
                                batch[name]=[];
                                init[name]=[];
                                for(let i=0; i<msg[name].length; i++){
                                    batch[name].push({});
                                    init[name].push({});
                                    for(let item in msg[name][i]){
                                        batch[name][i][item]=[];
                                        init[name][i][item]=[];
                                    }
                                }
                            }
                    };
                    _this.getData.push({
                        data:msg,
                        batch:batch,
                        init:init,
                        model:model,
                        type:res.data.type
                    });
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            },
        },
        components:mod
    }
</script>
<style scoped>
    .hd{ background:#464c5b; color:#fff; }
    h3{ background:#dddee1; padding:2px 5px 2px 20px; line-height:30px; margin-top:-1px; }
</style>



// WEBPACK FOOTER //
// src/components/template/modifyTemplate.vue